import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AlertController, AlertButton, ToastController } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { _throw } from 'rxjs/observable/throw';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

import * as moment from 'moment';

import { CoffeCategory } from '../../interfaces/CoffeCategory.interface'
import { CoffeService } from '../../interfaces/CoffeService.interface';
import { LoyalityPoints } from '../../interfaces/LoyalityPoints.interface';
@Injectable()
export class CoffeShopService {
  public shop = null;
  public user = null;
  public barbers = null;
  public allBarbers = null;
  public coffeShop: any = null;
  public lastBookingDate = null;
  public firstBookingDate = null;
  public categories: CoffeCategory[] = [];
  public selectedServices: CoffeService[] = [];
  public bookingTimes: BookingTimes[] = [];
  public bookingDates: BookingDates[] = [];
  public currencySymbol: string = '';
  public selectedDate: string = '';
  public selectedTime: string = '';
  
  public totalOrders: number = 0;
  public bookingType: number = null;

  public showChooseDate: boolean = false;

  constructor(private http: HttpClient, private alertCtrl: AlertController,public toastCtrl :ToastController) { }
  getShopLocation(owner_id): Observable<any> {
    return this.http.get(`/teams/${owner_id}/location`)
    .pipe(catchError((error: HttpErrorResponse) => _throw(new Error(error.message))));
  }
  getLoyalityPoinst(teamid: number): Observable<LoyalityPoints> {
    return this.http.get<LoyalityPoints>(`/loyalty-points/${localStorage.getItem('tuid')}/teams/${teamid}`)
      .pipe(catchError((error: HttpErrorResponse) => _throw(new Error(error.message))));
  }
  getPromoLimits(teamid: number): Observable<any> {
    return this.http.get(`/users/${localStorage.getItem('tuid')}/teams/${teamid}/promo_products`)
      .pipe(catchError((error: HttpErrorResponse) => _throw(new Error(error.message))));
  }
  public getCoffeShop(shopId: number): Observable<any> {
    return this.http.get<any>(`/teams/${shopId}`)
      .pipe(catchError((error: HttpErrorResponse) => _throw(new Error(error.message))))
  }
  public getCategoriesWithServices(teamId: number, owner_id: number, tuid: number): Observable<CoffeCategory[]> {
    return this.http.get<CoffeCategory[]>(`/teams/${teamId}/members/${owner_id}/active-categories-with-services?tuid=${tuid}`)
      .pipe(catchError((error: HttpErrorResponse) => _throw(new Error(error.message))))
  }
  public getStaffHolidays(shopId: string): Observable<any> {
    return this.http.get(`/teams/${shopId}/staff-holiday`)
      .pipe(catchError((error: HttpErrorResponse) => _throw(new Error(error.message))))
  }

  public checkCouponcode(coupon_code: string): Observable<any> {
    return this.http.post(`/check-coupon-availability`, {
      team_id: this.coffeShop.id, 
      coupon_code : coupon_code
    })
      .pipe(catchError((error: HttpErrorResponse) => _throw(new Error(error.message))))
  }


  public getAvailableBookingTimes(date: string, barber: any): Observable<any> {
    // return this.http.post(`/check-advanced-booking-availability`, {
      return this.http.post(`/check-booking-availability`, {
      bookingDate: date,
      bookingTime: 0,
      team: this.shop.id,
      teamMember: barber,
      termsAccepted: true,
      type: 2, // Advanced booking
      user: localStorage.getItem('tuid')
    })
      .pipe(catchError((error: HttpErrorResponse) => _throw(new Error(error.message))))
  }
  public advancedBookingRequest(booking: { date: string, available: boolean }, formatting: boolean): Observable<any> {
    let formattedDate = ''
    if (formatting) {
      formattedDate = booking.date ? this.requestDateFormatter(booking.date) : booking.date;
    }
    else {
      formattedDate = booking.date
    }
    return this.http.get(`/teams/${this.coffeShop.id}/staff?`, { params: { 'has_advanced_booking_date': formattedDate } });
  }
  public trackAdnvancedSettingsState(dayName): boolean  {
    const range: any = [];
    let start = new Date();
    const end = new Date(new Date().setDate(new Date().getDate() + this.coffeShop.settings.num_days_bookings_can_be_made_in_advance));
    if (this.coffeShop.settings.num_days_bookings_can_be_made_in_advance === 0) {
      range.push(moment(new Date()).format('dddd'));
    } else {
      while (start.getTime() <= end.getTime()) {
        range.push(moment(start).format('dddd'));
        start = new Date(start.getTime() + 86400000);
      }
    }
    if (range.includes(dayName)) {
      return true;
    } else {
      return false;
    }
  }

  public getBookingDate(day) {
    const today = moment().isoWeekday();
    let dayInNeed = moment().isoWeekday(day).weekday();

    // if we haven't yet passed the day of the week that I need:
    if (today <= dayInNeed) {
      // then just give me this week's instance of that day
      return moment().isoWeekday(dayInNeed).format('DD/MM/YYYY');
    }

    // otherwise, give me *next week's* instance of that same day
    return moment().add(1, 'weeks').isoWeekday(dayInNeed).format('DD/MM/YYYY');
  }
  public requestDateFormatter(inputFormat): string {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/')
  }
  public setPrice(price: number, shopPlus: boolean): string {
    if (price === null || price === undefined) { return ''; }
    
    if(typeof(price) == 'string'){
        price = Number(price);
    }
    
    return (shopPlus ? '+' : '') + this.currencySymbol + price.toFixed(2);
  }
  public filterAvailableUsers(shop) {
    let filteredUsers = [];

    for (var i = 0; i < shop.users.length; i++) {
      let user = shop.users[i];

      // Remove user if user has holiday today
      if (user.holidays.holidayToday === true) {
        continue;
      }

      // Remove user if user is not checked in at the current team
      if (!user.current_active_team || user.current_active_team !== shop.id) {
        continue;
      }

      filteredUsers.push(user);

    }

    shop.users = filteredUsers;
    return shop;
  }
  daysConfig(barber) {
    let daysConfig: any[] = [];
    // Iterate over the barbers holiday and disable all unavailable dates
    if (barber.holiday) {
      barber.holiday.forEach(holiday => {
        holiday.dates.forEach(holidayDate => {

          let date = moment(holidayDate, 'DD-MM-YYYY');
          daysConfig.push({
            date: new Date(date.get('year'), date.get('month'), date.get('date')),
            marked: false,
            disable: true
          });

        });
      });
    }

    return daysConfig;
  }

  disableWeeks(barber) {
    // Disable advanced booking working days
    let disableWeeks: any = [];

    if (Array.isArray(barber.advanced_booking_hours)) {
      barber.advanced_booking_hours = barber.advanced_booking_hours[0];
    }

    if (!barber.advanced_booking_hours.monday) disableWeeks.push(1);
    if (!barber.advanced_booking_hours.tuesday) disableWeeks.push(2);
    if (!barber.advanced_booking_hours.wednesday) disableWeeks.push(3);
    if (!barber.advanced_booking_hours.thursday) disableWeeks.push(4);
    if (!barber.advanced_booking_hours.friday) disableWeeks.push(5);
    if (!barber.advanced_booking_hours.saturday) disableWeeks.push(6);
    if (!barber.advanced_booking_hours.sunday) disableWeeks.push(0);

    return disableWeeks;
  }

  enabledDaysInAWeek(barber) {
    let enabledDays: any = [];
    if (Array.isArray(barber.advanced_booking_hours)) {
      barber.advanced_booking_hours = barber.advanced_booking_hours[0];
    }

    if (barber.advanced_booking_hours && barber.advanced_booking_hours.monday && (this.shop && this.shop.hours['monday'])) enabledDays.push(1);
    if (barber.advanced_booking_hours && barber.advanced_booking_hours.tuesday && (this.shop && this.shop.hours['tuesday'])) enabledDays.push(2);
    if (barber.advanced_booking_hours && barber.advanced_booking_hours.wednesday && (this.shop && this.shop.hours['wednesday'])) enabledDays.push(3);
    if (barber.advanced_booking_hours && barber.advanced_booking_hours.thursday && (this.shop && this.shop.hours['thursday'])) enabledDays.push(4);
    if (barber.advanced_booking_hours && barber.advanced_booking_hours.friday && (this.shop && this.shop.hours['friday'])) enabledDays.push(5);
    if (barber.advanced_booking_hours && barber.advanced_booking_hours.saturday && (this.shop && this.shop.hours['saturday'])) enabledDays.push(6);
    if (barber.advanced_booking_hours && barber.advanced_booking_hours.sunday && (this.shop && this.shop.hours['sunday'])) enabledDays.push(0);

    return enabledDays;
  }

  options() {
    const options: any = {}
    // Prevent user from booking too far in advance i.e. respect the team setting
    if (this.lastBookingDate) options.to = this.lastBookingDate;
    if (this.firstBookingDate) options.from = this.firstBookingDate;
    return options;
  }
  public convert12to24(time: string): string {
    let hours = Number(time.match(/^(\d+)/)[1]);
    let minutes = Number(time.match(/:(\d+)/)[1]);
    let AMPM = time.match(/\s(.*)$/)[1];
    if (AMPM == "PM" && hours < 12) hours = hours + 12;
    if (AMPM == "AM" && hours == 12) hours = hours - 12;
    let sHours = hours.toString();
    let sMinutes = minutes.toString();
    if (hours < 10) sHours = "0" + sHours;
    if (minutes < 10) sMinutes = "0" + sMinutes;
    return sHours + ":" + sMinutes;
  }
  public clearServiceData(clearShop: boolean): void {
    if (clearShop) {
      this.coffeShop = null;
      this.shop = null;
    }
    this.user = null;
    this.barbers = null;
    this.allBarbers = null;
    this.categories = [];
    this.selectedServices = [];
    this.totalOrders = 0;
  }
  public clearDates(): void {
    this.selectedDate = '';
    this.selectedTime = '';
    this.bookingDates = [];
    this.bookingTimes = [];
    this.lastBookingDate = null;
    this.firstBookingDate = null;
    this.showChooseDate = false;
  }
  public presentAlert(title: string, subTitle: string, enableBackdropDismiss: boolean, buttons: (string | AlertButton)[]): void {
    let alert = this.alertCtrl.create({
      title,
      subTitle,
      enableBackdropDismiss,
      buttons
    });

    alert.present();
  }


   presentToast(msg) {
    const toast = this.toastCtrl.create({
      message: msg,
      duration : 3000
    });
      toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });
      toast.present();
   }

  public SuccessAlert(): void {
    let alert = this.alertCtrl.create({
      title : 'Success',
      message : "Congratulations, your Promo Code has been successfully applied",
      buttons :['Continue'],
      mode:'ios',
      cssClass:'custom-alert'
    });

    alert.present();
   }

}
interface BookingDates {
  date: Date;
  available: boolean;
}
interface BookingTimes {
  date: string;
  available: boolean;
  booking_type?: number;
}


// WEBPACK FOOTER //
// ./src/providers/coffe-shop/coffe-shop.service.ts